(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9939],{

/***/ 2691:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing",
      function () {
        return __webpack_require__(46531);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pricing; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./components/common/layout-container.tsx
var layout_container = __webpack_require__(50336);
;// CONCATENATED MODULE: ./components/pricing/hero.tsx



function Hero() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_container/* LayoutContainer */.k, {
        pos: "relative",
        verticalPadding: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
            align: "center",
            textAlign: "center",
            spacing: 4,
            py: "78px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Heading */.X6, {
                    as: "h1",
                    size: "h1",
                    children: [
                        "Pricing Built for",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                            bgGradient: "linear-gradient(271.19deg, #17CCFC -28.89%, #6C47FF 80.53%)",
                            bgClip: "text",
                            children: "Businesses of All Sizes"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                    fontSize: "24px",
                    fontWeight: 400,
                    display: {
                        base: "none",
                        md: "flex"
                    },
                    children: "Start for free, and scales with your success. We never charge for inactive users."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                    fontSize: "16px",
                    fontWeight: 400,
                    display: {
                        base: "flex",
                        md: "none"
                    },
                    children: "Start for free, always know what you'll pay."
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/react-calendly/dist/index.es.js
var index_es = __webpack_require__(20761);
// EXTERNAL MODULE: ./lib/constants.ts
var constants = __webpack_require__(58038);
// EXTERNAL MODULE: ./pages/index.tsx + 31 modules
var pages = __webpack_require__(16263);
;// CONCATENATED MODULE: ./components/pricing/cards.tsx






function TalkToAnExpertCTA() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
        w: "159px",
        onClick: ()=>{
            (0,index_es/* openPopupWidget */.Bz)({
                url: constants/* URLS.calendlyUrl */.ns.calendlyUrl
            });
        },
        fontSize: "14px",
        letterSpacing: "-0.02",
        lineHeight: "24px",
        boxShadow: "0px 4px 8px -2px rgba(57, 67, 86, 0.12)",
        borderRadius: "8px",
        padding: "8px 20px",
        children: "Talk with an Expert"
    });
}
function StartBuildingNowCTA(param) {
    let { section  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        legacyBehavior: true,
        href: "https://dashboard.clerkstage.dev" + "/sign-up",
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
            w: "158px",
            h: "40px",
            padding: "8px 20px",
            pos: "relative",
            top: 0,
            border: section == "Business" ? "1px" : "0px",
            borderColor: section == "Business" ? "primary.500" : "none",
            variant: "white",
            zIndex: 100,
            onClick: ()=>{
                pages.analytics.track("Marketing_Pricing_Start Building Button Clicked", {
                    ClickedOn: section,
                    surface: "Marketing",
                    location: "Pricing"
                });
                (0,pages.rudderTrack)("Marketing_Pricing_Start Building Button Clicked", {
                    ClickedOn: section,
                    surface: "Marketing",
                    location: "Pricing"
                });
            },
            children: "Start building now"
        })
    });
}
function MostPopularBadge() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
        pos: "absolute",
        display: "flex",
        flexDir: "column",
        alignItems: "center",
        right: 2,
        top: -8,
        zIndex: 1000,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                fontWeight: 900,
                letterSpacing: "0.12em",
                fontSize: "8px",
                lineHeight: "24px",
                bgGradient: "linear-gradient(271.19deg, #17CCFC -28.89%, #6C47FF 80.53%)",
                bgClip: "text",
                children: "MOST POPULAR!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "41",
                height: "48",
                viewBox: "0 0 41 48",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.42195 0.900879H38.5794C39.1787 0.900879 39.7535 1.13897 40.1773 1.56277C40.6011 1.98657 40.8392 2.56137 40.8392 3.16072V46.7213C40.8394 46.9099 40.7924 47.0955 40.7025 47.2612C40.6126 47.427 40.4826 47.5676 40.3245 47.6702C40.1663 47.7729 39.985 47.8344 39.797 47.849C39.6091 47.8637 39.4204 47.831 39.2483 47.7541L20.5007 39.3859L1.75304 47.7518C1.58107 47.8287 1.39262 47.8613 1.20482 47.8468C1.01703 47.8323 0.835842 47.771 0.677751 47.6686C0.51966 47.5662 0.389675 47.4259 0.29962 47.2605C0.209564 47.095 0.162294 46.9097 0.162109 46.7213V3.16072C0.162109 2.56137 0.400199 1.98657 0.824 1.56277C1.2478 1.13897 1.8226 0.900879 2.42195 0.900879ZM20.5007 26.889L27.1423 30.3805L25.8745 22.9863L31.2462 17.748L23.8204 16.6678L20.5007 9.94023L17.1787 16.6678L9.75512 17.748L15.1268 22.9863L13.8612 30.3805L20.5007 26.889Z",
                        fill: "url(#paint0_linear_321_5449)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                            id: "paint0_linear_321_5449",
                            x1: "41.0005",
                            y1: "48",
                            x2: "0.000486167",
                            y2: "1",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    stopColor: "#17CCFC"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "1",
                                    stopColor: "#6C47FF"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
function Card(param) {
    let { badgeText , description , featuresTitle , features , price  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
        textAlign: "center",
        flexDir: "row",
        w: "300px",
        h: "570px",
        shadow: "dropShadow3",
        pos: "relative",
        bgGradient: badgeText == "Business" ? "linear(to-br, #E5F8FF 0%, white 70%,  #EAEAFD 100%)" : badgeText == "Hobby" ? "linear(to-bl, #E5F8FF 0%, white 20%,  #EAEAFD 100%)" : badgeText == "Free" ? "linear(to-bl, #E5F8FF 0%, white 70%,  #EAEAFD 100%)" : "linear(to-tr, #E5F8FF 0%, white 80%,  #EAEAFD 100%)",
        borderRadius: "8px",
        children: [
            badgeText === "Business" && /*#__PURE__*/ (0,jsx_runtime.jsx)(MostPopularBadge, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                align: "center",
                direction: "column",
                borderRadius: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                        px: "24px",
                        py: "4px",
                        rounded: "full",
                        mt: "36px",
                        mb: "24px",
                        border: "1px solid #6C47FF",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                            as: "h3",
                            size: "md",
                            color: "primary.500",
                            children: badgeText
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                        gap: 2,
                        align: "flex-end",
                        mb: 2,
                        pos: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                fontSize: "40px",
                                lineHeight: "48px",
                                color: "primary.500",
                                fontWeight: 500,
                                letterSpacing: "-0.01em",
                                children: price
                            }),
                            price !== "$0" && price !== "Contact Us" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                fontSize: "32px",
                                lineHeight: "48px",
                                color: "primary.500",
                                fontWeight: 500,
                                letterSpacing: "-0.01em",
                                ml: "-.25em",
                                children: "/mo"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                        textStyle: "paragraph-sm",
                        color: "black",
                        mb: 4,
                        px: 4,
                        children: description
                    }),
                    badgeText === "Enterprise" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TalkToAnExpertCTA, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StartBuildingNowCTA, {
                        section: badgeText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Divider */.iz, {
                        my: "24px"
                    }),
                    featuresTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                        size: "sm",
                        color: "black",
                        mb: 6,
                        children: featuresTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Stack */.Kq, {
                        color: "black",
                        gap: "12px",
                        children: features.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                textStyle: "paragraph-sm",
                                children: feature
                            }, feature))
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 51 modules
var modal_dist_index_esm = __webpack_require__(48821);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/close-button/dist/index.esm.js
var close_button_dist_index_esm = __webpack_require__(95868);
;// CONCATENATED MODULE: ./components/pricing/plans/plans-content.ts
const ToolTips = [
    {
        name: "Monthly active users",
        tooltip: "A user is 'active' if they visit your application."
    },
    {
        name: "Monthly active organizations",
        tooltip: "An organization is 'active' if there are at least 2 members, and at least one of those members is active."
    },
    {
        name: "Verification SMSs",
        tooltip: "SMS rates depend on the country.  Our SMS vendor is Twilio, and we passthrough their fees."
    },
    {
        name: "Hosted pages",
        tooltip: 'To quickly add authentication to your app, leverage <a href="/docs/authentication/using-clerk-hosted-pages" target="_blank" rel="noopener">Clerk\'s hosted pages</a>.'
    },
    {
        name: "Build your own UIs",
        tooltip: 'For completely custom UIs, leverage <a href="/docs/component-customization/appearance-prop" target="_blank" rel="noopener">Clerk\'s powerful APIs</a>.'
    },
    {
        name: "Custom domain",
        tooltip: "Deploy hosted pages and send emails from your own domain."
    },
    {
        name: "Remove Clerk branding",
        tooltip: "Remove the 'Secured by Clerk' branding in Clerk's pre-built components & hosted pages."
    },
    {
        name: "Custom auth methods",
        tooltip: "Build your own authentication methods."
    },
    {
        name: "SMS Multifactor auth",
        tooltip: "Allow users to add a phone as a second factor."
    },
    {
        name: "TOTP Multifactor auth",
        tooltip: "Allow users to add a TOTP device for enhanced security."
    },
    {
        name: "Account linking",
        tooltip: "Prevent duplicate accounts when the same user signs in with a new strategy. (e.g. social sign-in after signing up by email)."
    },
    {
        name: "Custom JWT SSO templates",
        tooltip: "Generate dynamic JWTs directly from the frontend and connect via JWT SSO to Hasura, Supabase, etc."
    },
    {
        name: "Allowlist/blocklist",
        tooltip: "Only allow certain people to access your application."
    },
    {
        name: "SMS multifactor auth",
        tooltip: "Also supports backup codes."
    },
    {
        name: "TOTP multifactor auth",
        tooltip: "Also supports backup codes."
    },
    {
        name: "User switching",
        tooltip: "Allow users to sign into multiple accounts simultaneously and switch between them."
    },
    {
        name: "Device management",
        tooltip: "Allow users to manage sessions across devices and sign out remotely."
    },
    {
        name: "Basic RBAC",
        tooltip: "Users can either be an 'Admin' or a 'Member'."
    },
    {
        name: "Custom RBAC",
        tooltip: "Define your own roles and permissions."
    },
    {
        name: "Exportable user data",
        tooltip: "Export user data, including the bcrypt hash of user passwords."
    },
    {
        name: "Password complexity requirements",
        tooltip: "Add additional requirements for passwords, such as character limits or requiring numbers."
    }
];
const comingSoon = [
    {
        name: "Custom Roles",
        text: "Q2 2023"
    },
    {
        name: "SAML",
        text: "Q2 2023"
    }
];
const plans = {
    free: {
        name: "Free",
        description: "Unlimited sign-ins, no credit card required. Limit 5,000 monthly active users.",
        features: {
            "Platform pricing": {
                title: "Platform pricing",
                "Base price": "Free",
                "Included MAUs": "5000",
                "Additional MAUs": "-",
                "MAU limit": "5,000",
                "Included MAOs": "10",
                "Additional MAOs": "-",
                "Allowed Clerk collaborators": "3",
                "Additional Clerk collaborators": "$20 each"
            },
            "Messaging pricing": {
                title: "Messaging pricing",
                "Verification emails": "Included",
                "Invitation emails": "Included",
                "Transactional emails": null,
                "Verification SMSs": null,
                "Transactional SMSs": null
            },
            "UI & Branding": {
                title: "UI & Branding",
                "Hosted pages": true,
                "Pre-built components": true,
                "CSS customization": true,
                "Build your own UIs": true,
                "Custom domain": true,
                "Remove Clerk branding": false
            },
            "Authentication features": {
                title: "Authentication features",
                Passwords: true,
                "Password complexity requirements": false,
                "Magic links / Email codes": true,
                "SMS phone codes": false,
                "Social logins / Web3 wallets": "Up to 3",
                "Invite only": false,
                "Custom auth methods": true,
                "Allowlist/blocklist": false,
                "SMS multifactor auth": false,
                "TOTP multifactor auth": false,
                SAML: false
            },
            "User management": {
                title: "User management",
                "Admin dashboard": true,
                "Account linking": true,
                "User bans": false,
                "User impersonation": false
            },
            "Session features": {
                title: "Session features",
                "Revocable sessions": true,
                "Custom JWT SSO templates": true,
                "Custom session tokens": true,
                "Custom session duration": false,
                "User switching": false,
                "Device management": false
            },
            "Organizations features": {
                title: "Organizations features",
                "Allowed users per org": "3",
                "Invitation emails": true,
                "Basic RBAC": true,
                "Custom Roles": false
            },
            "Support & Compliance": {
                title: "Support & Compliance",
                "Exportable user data": true,
                "Community Support": true,
                "Priority support": false,
                "SOC2 Report": false,
                "HIPAA Report / BAA": false
            }
        }
    },
    hobby: {
        name: "Hobby",
        description: "Essential features for launching or growing any application.",
        features: {
            "Platform pricing": {
                title: "Platform pricing",
                "Base price": "$25",
                "Included MAUs": "1,000",
                "Additional MAUs": "$0.02 each",
                "MAU limit": "Unlimited",
                "Included MAOs": "100",
                "Additional MAOs": "$0.25 each",
                "Allowed Clerk collaborators": "3",
                "Additional Clerk collaborators": "$20 each"
            },
            "Messaging pricing": {
                title: "Messaging pricing",
                "Verification emails": "Included",
                "Invitation emails": "Included",
                "Transactional emails": "$0.001 each",
                "Verification SMSs": "Market rate",
                "Transactional SMSs": "Market rate"
            },
            "UI & Branding": {
                title: "UI & Branding",
                "Hosted pages": true,
                "Pre-built components": true,
                "CSS customization": true,
                "Build your own UIs": true,
                "Custom domain": true,
                "Remove Clerk branding": true
            },
            "Authentication features": {
                title: "Authentication features",
                Passwords: true,
                "Password complexity requirements": false,
                "Magic links / Email codes": true,
                "SMS phone codes": true,
                "Social logins / Web3 wallets": "Up to 3",
                "Invite only": false,
                "Custom auth methods": true,
                "Allowlist/blocklist": true,
                "SMS multifactor auth": false,
                "TOTP multifactor auth": false,
                SAML: false
            },
            "User management": {
                title: "User management",
                "Admin dashboard": true,
                "Account linking": true,
                "User bans": false,
                "User impersonation": false
            },
            "Session features": {
                title: "Session features",
                "Revocable sessions": true,
                "Custom JWT SSO templates": true,
                "Custom session tokens": true,
                "Custom session duration": false,
                "User switching": false,
                "Device management": false
            },
            "Organizations features": {
                title: "Organizations features",
                "Allowed users per org": "10",
                "Invitation emails": true,
                "Basic RBAC": true,
                "Custom Roles": false
            },
            "Support & Compliance": {
                title: "Support & Compliance",
                "Exportable user data": true,
                "Community Support": true,
                "Priority support": false,
                "SOC2 Report": false,
                "HIPAA Report / BAA": false
            }
        }
    },
    business: {
        name: "Business",
        description: "Everything you need for a business of any size.",
        features: {
            "Platform pricing": {
                title: "Platform pricing",
                "Base price": "$99",
                "Included MAUs": "1,000",
                "Additional MAUs": "$0.05 each",
                "MAU limit": "Unlimited",
                "Included MAOs": "100",
                "Additional MAOs": "$1 each",
                "Allowed Clerk collaborators": "3",
                "Additional Clerk collaborators": "$20 each"
            },
            "Messaging pricing": {
                title: "Messaging pricing",
                "Verification emails": "Included",
                "Invitation emails": "Included",
                "Transactional emails": "$0.001 each",
                "Verification SMSs": "Market",
                "Transactional SMSs": "Market"
            },
            "UI & Branding": {
                title: "UI & Branding",
                "Hosted pages": true,
                "Pre-built components": true,
                "CSS customization": true,
                "Build your own UIs": true,
                "Custom domain": true,
                "Remove Clerk branding": true
            },
            "Authentication features": {
                title: "Authentication features",
                Passwords: true,
                "Password complexity requirements": true,
                "Magic links / Email codes": true,
                "SMS phone codes": true,
                "Social logins / Web3 wallets": "Unlimited",
                "Invite only": true,
                "Custom auth methods": true,
                "Allowlist/blocklist": true,
                "SMS multifactor auth": true,
                "TOTP multifactor auth": true,
                SAML: false
            },
            "User management": {
                title: "User management",
                "Admin dashboard": true,
                "Account linking": true,
                "User bans": true,
                "User impersonation": true
            },
            "Session features": {
                title: "Session features",
                "Revocable sessions": true,
                "Custom JWT SSO templates": true,
                "Custom session tokens": true,
                "Custom session duration": true,
                "User switching": true,
                "Device management": true
            },
            "Organizations features": {
                title: "Organizations features",
                "Allowed users per org": "Unlimited",
                "Invitation emails": true,
                "Basic RBAC": true,
                "Custom Roles": false
            },
            "Support & Compliance": {
                title: "Support & Compliance",
                "Exportable user data": true,
                "Community Support": true,
                "Priority support": true,
                "SOC2 Report": true,
                "HIPAA Report / BAA": false
            }
        }
    },
    enterprise: {
        name: "Enterprise",
        description: "Custom contracts and enterprise support.",
        features: {
            "Platform pricing": {
                title: "Platform pricing",
                "Base price": "Contact sales",
                "Included MAUs": "Contact sales",
                "Additional MAUs": "Volume discounts",
                "MAU limit": "Unlimited",
                "Included MAOs": "Contact sales",
                "Additional MAOs": "Volume discounts",
                "Allowed Clerk collaborators": "3",
                "Additional Clerk collaborators": "$20 each"
            },
            "Messaging pricing": {
                title: "Messaging pricing",
                "Verification emails": "Included",
                "Invitation emails": "Included",
                "Transactional emails": "$0.001 each",
                "Verification SMSs": "Market",
                "Transactional SMSs": "Market"
            },
            "UI & Branding": {
                title: "UI & Branding",
                "Hosted pages": true,
                "Pre-built components": true,
                "CSS customization": true,
                "Build your own UIs": true,
                "Custom domain": true,
                "Remove Clerk branding": true
            },
            "Authentication features": {
                title: "Authentication features",
                Passwords: true,
                "Password complexity requirements": true,
                "Magic links / Email codes": true,
                "SMS phone codes": true,
                "Social logins / Web3 wallets": "Unlimited",
                "Invite only": true,
                "Custom auth methods": true,
                "Allowlist/blocklist": true,
                "SMS multifactor auth": true,
                "TOTP multifactor auth": true,
                SAML: false
            },
            "User management": {
                title: "User management",
                "Admin dashboard": true,
                "Account linking": true,
                "User bans": true,
                "User impersonation": true
            },
            "Session features": {
                title: "Session features",
                "Revocable sessions": true,
                "Custom JWT SSO templates": true,
                "Custom session tokens": true,
                "Custom session duration": true,
                "User switching": true,
                "Device management": true
            },
            "Organizations features": {
                title: "Organizations features",
                "Allowed users per org": "Unlimited",
                "Invitation emails": true,
                "Basic RBAC": true,
                "Custom Roles": false
            },
            "Support & Compliance": {
                title: "Support & Compliance",
                "Exportable user data": true,
                "Community Support": true,
                "Priority support": true,
                "SOC2 Report": true,
                "HIPAA Report / BAA": true
            }
        }
    }
};

// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/QuestionMarkCircleIcon.js
var QuestionMarkCircleIcon = __webpack_require__(2905);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/CheckIcon.js
var CheckIcon = __webpack_require__(58057);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/XIcon.js
var XIcon = __webpack_require__(68163);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/PlusIcon.js
var PlusIcon = __webpack_require__(25159);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.esm.js + 1 modules
var popover_esm = __webpack_require__(25067);
;// CONCATENATED MODULE: ./components/common/tooltip.tsx




const Tooltip = (param)=>/*#__PURE__*/ {
    let { title , content , popoverClassName , buttonClassName , panelClassName , contentClassName  } = param;
    return (0,jsx_runtime.jsxs)(popover_esm/* Popover */.J, {
        className: classnames_default()(popoverClassName),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_esm/* Popover.Button */.J.Button, {
                className: classnames_default()("block", buttonClassName),
                title: "Learn more",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_esm/* Popover.Panel */.J.Panel, {
                className: classnames_default()("absolute z-10 transform bg-white sm:px-0", panelClassName),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("block max-w-xs px-4 py-2 text-sm font-normal text-left text-gray-500  shadow-lg ring-1 ring-black ring-opacity-5 ", contentClassName),
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                })
            })
        ]
    });
};
Tooltip.defaultProps = {
    popoverClassName: undefined,
    buttonClassName: undefined,
    panelClassName: undefined,
    contentClassName: undefined
};

// EXTERNAL MODULE: ./node_modules/react/cjs/react.production.min.js
var react_production_min = __webpack_require__(72408);
;// CONCATENATED MODULE: ./components/pricing/plans/plans-table-mobile.tsx









const buttonStyle = {
    variant: "white",
    border: "1px solid",
    borderColor: "gray.100",
    boxShadow: "none"
};
const FeatureList = (param)=>{
    let { list  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Flex */.kC, {
        flexDir: "row",
        w: "100%",
        justifyContent: "space-between",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* List */.aV, {
            w: "100%",
            children: Object.entries(list).map((entry, index)=>{
                const feature = entry[1];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* ListItem */.HC, {
                    my: 2,
                    display: "flex",
                    flexDir: "row",
                    justifyContent: "space-between",
                    alignContent: "center",
                    minH: "57px",
                    w: "100%",
                    borderBottom: "1px solid #E4E9F2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                            children: entry[0] !== "title" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                py: "16px",
                                display: "flex",
                                flexDir: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                children: [
                                    entry[0],
                                    ToolTips.map((tip)=>{
                                        if (tip.name === entry[0]) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip, {
                                                popoverClassName: "ml-1.5",
                                                panelClassName: "left-4 sm:left-10 lg:left-0 !mt-2",
                                                buttonClassName: "relative",
                                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionMarkCircleIcon/* default */.Z, {
                                                    className: "inline-block w-5 h-5 text-gray-400 fill-current -top-0.5"
                                                }),
                                                content: tip.tooltip
                                            }, tip.name);
                                        }
                                    }),
                                    comingSoon.map((feature)=>{
                                        if (feature.name === entry[0]) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                fontSize: "xs",
                                                ml: 3,
                                                px: 1,
                                                color: "primary.500",
                                                display: "flex",
                                                flexDir: "row",
                                                justifyContent: "space-between",
                                                bgColor: "primary.25",
                                                borderRadius: "0.25rem",
                                                overflow: "visible",
                                                whiteSpace: "nowrap",
                                                children: feature.text
                                            }, feature.name);
                                        }
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                textAlign: "left",
                                my: 2,
                                fontWeight: "semibold",
                                fontSize: "lg",
                                children: entry[1]
                            })
                        }),
                        entry[0] === "title" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                            h: "60px",
                            bg: "transparent"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                            w: "200px",
                            display: "flex",
                            flexDir: "row",
                            justifyContent: "flex-end",
                            py: "16px",
                            children: typeof feature === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                textAlign: "right",
                                children: feature
                            }) : feature === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                as: CheckIcon/* default */.Z,
                                color: "primary.500",
                                pos: "relative",
                                h: "24px"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                children: "—"
                            })
                        })
                    ]
                }, index);
            })
        })
    });
};
const plans_table_mobile_Card = (param)=>{
    let { plan , isExpanded , setExpandedSection  } = param;
    const { name , description , features  } = plan;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
                isOpen: isExpanded,
                onClose: ()=>setExpandedSection(null),
                size: "full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalBody */.fe, {
                                display: "flex",
                                flexDir: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                                        flexDir: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mt: "-12px",
                                        mb: "24px",
                                        onClick: ()=>setExpandedSection(null),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                as: close_button_dist_index_esm/* CloseButton */.P,
                                                color: name == "Business" ? "primary.500" : "gray.700"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                textTransform: "capitalize",
                                                fontWeight: 700,
                                                fontSize: "11px",
                                                lineHeight: "24px",
                                                mt: "4px",
                                                children: "CLOSE ALL FEATURES"
                                            })
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                                        direction: "column",
                                        flex: 1,
                                        textAlign: "center",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        bg: "white",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Heading */.X6, {
                                                size: "h2",
                                                fontSize: "24px",
                                                children: [
                                                    name,
                                                    " Plan"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                fontSize: "13px",
                                                mb: "18px",
                                                fontWeight: 400,
                                                letterSpacing: "-0.02em",
                                                lineHeight: "24px",
                                                maxW: "240px",
                                                children: description
                                            }),
                                            name === "Enterprise" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                ...buttonStyle,
                                                onClick: ()=>{
                                                    (0,index_es/* openPopupWidget */.Bz)({
                                                        url: constants/* URLS.calendlyUrl */.ns.calendlyUrl
                                                    });
                                                },
                                                children: "Contact sales"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                legacyBehavior: true,
                                                href: "https://dashboard.clerkstage.dev" + "/sign-up",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    as: "a",
                                                    ...buttonStyle,
                                                    w: "158px",
                                                    children: "Start building now"
                                                })
                                            })
                                        ]
                                    }, name),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                                        bg: "white",
                                        w: "80vw",
                                        pt: "40px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureList, {
                                                list: features["Platform pricing"]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureList, {
                                                list: features["Messaging pricing"]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureList, {
                                                list: features["UI & Branding"]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureList, {
                                                list: features["Authentication features"]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureList, {
                                                list: features["User management"]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureList, {
                                                list: features["Session features"]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureList, {
                                                list: features["Organizations features"]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureList, {
                                                list: features["Support & Compliance"]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalFooter */.mz, {
                                display: "flex",
                                flexDir: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                    mt: "10.5px",
                                    onClick: ()=>setExpandedSection(null),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                        as: XIcon/* default */.Z,
                                        h: "24px",
                                        w: "24px",
                                        color: name == "Business" ? "primary.500" : "gray.700"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Center */.M5, {
                mx: "24px",
                mt: {
                    base: 0,
                    lg: "40px"
                },
                borderRadius: "12px",
                p: "32px",
                flexDir: "column",
                border: name != "Business" ? "2px solid #E4E9F2" : "2px solid #694EFF",
                w: "343px",
                h: "256px",
                maxH: "256px",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.25)",
                zIndex: 1,
                bg: "white",
                pos: "relative",
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                        direction: "column",
                        flex: 1,
                        textAlign: "center",
                        alignItems: "center",
                        justifyContent: "center",
                        bg: "white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Heading */.X6, {
                                size: "h2",
                                fontSize: "24px",
                                children: [
                                    name,
                                    " Plan"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                fontSize: "13px",
                                mb: "18px",
                                fontWeight: 400,
                                letterSpacing: "-0.02em",
                                lineHeight: "24px",
                                maxW: "250px",
                                children: description
                            }),
                            name === "Enterprise" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                ...buttonStyle,
                                onClick: ()=>{
                                    (0,index_es/* openPopupWidget */.Bz)({
                                        url: constants/* URLS.calendlyUrl */.ns.calendlyUrl
                                    });
                                },
                                children: "Contact sales"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                legacyBehavior: true,
                                href: "https://dashboard.clerkstage.dev" + "/sign-up",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    as: "a",
                                    ...buttonStyle,
                                    w: "158px",
                                    children: "Start building now"
                                })
                            })
                        ]
                    }, name),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                textTransform: "capitalize",
                                fontWeight: 700,
                                fontSize: "11px",
                                lineHeight: "24px",
                                mt: "20px",
                                children: "EXPAND TO EXPLORE ALL FEATURES"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                onClick: ()=>setExpandedSection(name),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                    as: PlusIcon/* default */.Z,
                                    h: "18px",
                                    w: "18px",
                                    color: "#8F8F8F"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
function PlansTableMobile() {
    const [expandedSection, setExpandedSection] = (0,react_production_min.useState)("");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Flex */.kC, {
        flexDir: "column",
        bg: "white",
        gap: "42px",
        justifyContent: "center",
        alignItems: "center",
        children: Object.values(plans).map((plan, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(plans_table_mobile_Card, {
                    plan: plan,
                    isExpanded: expandedSection === plan.name,
                    setExpandedSection: setExpandedSection
                })
            }, index))
    });
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/table/dist/index.esm.js
var table_dist_index_esm = __webpack_require__(36696);
;// CONCATENATED MODULE: ./components/pricing/plans/plans-table.tsx









const plans_table_plans = [
    {
        title: "Free",
        featured: false,
        description: "Up to 5,000 monthly active users and unlimited sign-ins. No credit card required."
    },
    {
        title: "Hobby",
        featured: false,
        description: "Essential features for launching or growing any application."
    },
    {
        title: "Business",
        featured: true,
        description: "Everything you need for a business of any size."
    },
    {
        title: "Enterprise",
        featured: true,
        description: "Bulk discounts, custom contracts and enterprise support."
    }
];
const featureSections = [
    {
        name: "Platform pricing",
        features: [
            {
                name: "Base price",
                tiers: [
                    {
                        title: "Free",
                        value: "Free"
                    },
                    {
                        title: "Hobby",
                        value: "$25"
                    },
                    {
                        title: "Business",
                        value: "$99"
                    },
                    {
                        title: "Enterprise",
                        value: "Contact sales"
                    }
                ]
            },
            {
                name: "Included monthly active users (MAUs) ",
                tooltip: "A user is 'active' if they visit your application",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: "1,000"
                    },
                    {
                        title: "Business",
                        value: "1,000"
                    },
                    {
                        title: "Enterprise",
                        value: "Contact sales"
                    }
                ]
            },
            {
                name: "Additional MAUs",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: "$0.02 each"
                    },
                    {
                        title: "Business",
                        value: "$0.05 each"
                    },
                    {
                        title: "Enterprise",
                        value: "Volume discounts"
                    }
                ]
            },
            {
                name: "MAU limit",
                tiers: [
                    {
                        title: "Free",
                        value: "5,000"
                    },
                    {
                        title: "Hobby",
                        value: "Unlimited"
                    },
                    {
                        title: "Business",
                        value: "Unlimited"
                    },
                    {
                        title: "Enterprise",
                        value: "Unlimited"
                    }
                ]
            },
            {
                name: "Included monthly active orgs (MAOs)",
                tooltip: "An organization is 'active' if there are at least 2 members, and at least one of those members is active.",
                tiers: [
                    {
                        title: "Free",
                        value: "10"
                    },
                    {
                        title: "Hobby",
                        value: "100"
                    },
                    {
                        title: "Business",
                        value: "100"
                    },
                    {
                        title: "Enterprise",
                        value: "Contact sales"
                    }
                ]
            },
            {
                name: "Additional MAOs",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: "$0.25 each"
                    },
                    {
                        title: "Business",
                        value: "$1 each"
                    },
                    {
                        title: "Enterprise",
                        value: "Volume discounts"
                    }
                ]
            },
            {
                name: "Allowed Clerk collaborators",
                tiers: [
                    {
                        title: "Free",
                        value: "3"
                    },
                    {
                        title: "Hobby",
                        value: "3"
                    },
                    {
                        title: "Business",
                        value: "3"
                    },
                    {
                        title: "Enterprise",
                        value: "3"
                    }
                ]
            },
            {
                name: "Additional Clerk collaborators",
                tiers: [
                    {
                        title: "Free",
                        value: "$20 each"
                    },
                    {
                        title: "Hobby",
                        value: "$20 each"
                    },
                    {
                        title: "Business",
                        value: "$20 each"
                    },
                    {
                        title: "Enterprise",
                        value: "$20 each"
                    }
                ]
            }
        ]
    },
    {
        name: "Messaging pricing",
        features: [
            {
                name: "Verification emails",
                tiers: [
                    {
                        title: "Free",
                        value: "Included"
                    },
                    {
                        title: "Hobby",
                        value: "Included"
                    },
                    {
                        title: "Business",
                        value: "Included"
                    },
                    {
                        title: "Enterprise",
                        value: "Included"
                    }
                ]
            },
            {
                name: "Invitation emails",
                tiers: [
                    {
                        title: "Free",
                        value: "Included"
                    },
                    {
                        title: "Hobby",
                        value: "Included"
                    },
                    {
                        title: "Business",
                        value: "Included"
                    },
                    {
                        title: "Enterprise",
                        value: "Included"
                    }
                ]
            },
            {
                name: "Transactional emails",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: "$0.001 each"
                    },
                    {
                        title: "Business",
                        value: "$0.001 each"
                    },
                    {
                        title: "Enterprise",
                        value: "$0.001 each"
                    }
                ]
            },
            {
                name: "Verification SMSs",
                tooltip: "SMS rates depend on the country.  Our SMS vendor is Twilio, and we passthrough their fees.",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: "Market"
                    },
                    {
                        title: "Business",
                        value: "Market"
                    },
                    {
                        title: "Enterprise",
                        value: "Market"
                    }
                ]
            },
            {
                name: "Transactional SMSs",
                tooltip: "SMS rates depend on the country.  Our SMS vendor is Twilio, and we passthrough their fees.",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: "Market"
                    },
                    {
                        title: "Business",
                        value: "Market"
                    },
                    {
                        title: "Enterprise",
                        value: "Market"
                    }
                ]
            }
        ]
    },
    {
        name: "UIs & Branding",
        features: [
            {
                name: "Hosted pages",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Pre-built components",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "CSS customization",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Build your own UIs",
                tooltip: "For completely custom UIs, leverage Clerk's powerful APIs.",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Custom domain",
                tooltip: "Deploy hosted UIs and send emails from your own domain",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Remove Clerk branding",
                tooltip: "Remove the 'Secured by Clerk' branding in Clerk's pre-built components & hosted UIs",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            }
        ]
    },
    {
        name: "Authentication features",
        features: [
            {
                name: "Passwords",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Password complexity requirements",
                tooltip: "Add additional requirements for your user's passwords, such as minimum characters allowed or requiring the use of numbers.",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: false
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Magic links / Email Codes",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "SMS Phone codes",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Social logins / Web3 wallets",
                tiers: [
                    {
                        title: "Free",
                        value: "Up to 3"
                    },
                    {
                        title: "Hobby",
                        value: "Unlimited"
                    },
                    {
                        title: "Business",
                        value: "Unlimited"
                    },
                    {
                        title: "Enterprise",
                        value: "Unlimited"
                    }
                ]
            },
            {
                name: "Invite only",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: false
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Custom auth methods",
                tooltip: "Build your own authentication methods.",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Allowlist/Blocklist",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "SMS Multifactor auth",
                tooltip: "Allow users to add a phone as a second factor.",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: false
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "TOTP Multifactor auth",
                tooltip: "Allow users to add a TOTP device for enhanced security.",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: false
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "SAML",
                comingSoon: "Q2 2023",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: false
                    },
                    {
                        title: "Business",
                        value: false
                    },
                    {
                        title: "Enterprise",
                        value: false
                    }
                ]
            }
        ]
    },
    {
        name: "User management features",
        features: [
            {
                name: "Admin Dashboard",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Account linking",
                tooltip: "Prevent duplicate accounts when the same user signs in with a new strategy. (e.g. social sign-in after signing up by email)",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "User bans",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: false
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "User impersonation",
                tooltip: "Only allow certain people to access your application.",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: false
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            }
        ]
    },
    {
        name: "Session management features",
        features: [
            {
                name: "Revocable sessions",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Custom JWT SSO templates",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Custom session tokens",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Custom session duration",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: false
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "User switching",
                tooltip: "Allow users to sign into multiple accounts simultaneously and switch between them",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: false
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Device management",
                tooltip: "Allow users to manage sessions across devices and sign out remotely",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: false
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            }
        ]
    },
    {
        name: "Organizations features",
        features: [
            {
                name: "Allowed users per org",
                tiers: [
                    {
                        title: "Free",
                        value: "3"
                    },
                    {
                        title: "Hobby",
                        value: "10"
                    },
                    {
                        title: "Business",
                        value: "Unlimited"
                    },
                    {
                        title: "Enterprise",
                        value: "Unlimited"
                    }
                ]
            },
            {
                name: "Invitation emails",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Basic RBAC",
                tooltip: "Users can either be an 'Admin' or a 'Member'.",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Custom Roles",
                tooltip: "Define your own roles and permissions.",
                comingSoon: "Q2 2023",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: false
                    },
                    {
                        title: "Business",
                        value: false
                    },
                    {
                        title: "Enterprise",
                        value: false
                    }
                ]
            }
        ]
    },
    {
        name: "Support & Compliance",
        features: [
            {
                name: "Exportable user data",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ],
                tooltip: "Export user data, including the bcrypt hash of user passwords"
            },
            {
                name: "Community Support",
                tiers: [
                    {
                        title: "Free",
                        value: true
                    },
                    {
                        title: "Hobby",
                        value: true
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "Priority Support",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: false
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "SOC2 Report",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: false
                    },
                    {
                        title: "Business",
                        value: true
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            },
            {
                name: "HIPAA/BAA",
                tiers: [
                    {
                        title: "Free",
                        value: false
                    },
                    {
                        title: "Hobby",
                        value: false
                    },
                    {
                        title: "Business",
                        value: false
                    },
                    {
                        title: "Enterprise",
                        value: true
                    }
                ]
            }
        ]
    }
];
function PlansTable() {
    const featuresLength = featureSections.map((val)=>val.features).reduce((pre, cur)=>pre.concat(cur)).map((e)=>({
            name: e.name,
            tiers: e.tiers
        })).length;
    const height = featuresLength * 53 + featureSections.length * 100 + 340;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_container/* LayoutContainer */.k, {
        verticalPadding: "none",
        bg: "white",
        pos: "relative",
        w: "100vw",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* SimpleGrid */.MI, {
                    columns: 5,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Heading */.X6, {
                            size: "h4",
                            flex: 1,
                            py: 6,
                            children: [
                                "Explore All of",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                    as: "span",
                                    bgGradient: "linear-gradient(270.11deg, #17CCFC 0.1%, #6C47FF 97.84%), #262F40",
                                    bgClip: "text",
                                    children: "Clerk's Features"
                                })
                            ]
                        }),
                        Object.values(plans_table_plans).map((param)=>/*#__PURE__*/ {
                            let { title , description  } = param;
                            return (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                                direction: "column",
                                textAlign: "center",
                                justifyContent: "space-between",
                                py: 5,
                                flex: 1,
                                pos: "relative",
                                px: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                        w: "100%",
                                        borderWidth: "2px",
                                        py: 5,
                                        borderRadius: "xl",
                                        borderColor: "primary.500",
                                        pos: "absolute",
                                        top: "0%",
                                        left: "-1%",
                                        h: height,
                                        display: title === "Business" ? "block" : "none"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                        size: "h5",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                        fontSize: "13px",
                                        my: 4,
                                        lineHeight: "24px",
                                        letterSpacing: "-0.02em",
                                        children: description
                                    }),
                                    title === "Enterprise" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        border: "1px",
                                        onClick: ()=>{
                                            (0,index_es/* openPopupWidget */.Bz)({
                                                url: constants/* URLS.calendlyUrl */.ns.calendlyUrl
                                            });
                                        },
                                        w: "160px",
                                        alignSelf: "center",
                                        children: "Talk with an expert"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        legacyBehavior: true,
                                        href: "https://dashboard.clerkstage.dev" + "/sign-up",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                            as: "a",
                                            w: "160px",
                                            alignSelf: "center",
                                            variant: "white",
                                            border: title === "Business" ? "1px" : "0px",
                                            borderColor: "primary.500",
                                            children: "Start building now"
                                        })
                                    })
                                ]
                            }, title);
                        })
                    ]
                }),
                react.Children.toArray(featureSections.map((featureSection, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                fontWeight: "semibold",
                                fontSize: "lg",
                                pt: "56px",
                                pb: 4,
                                children: featureSection.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm/* Table */.iA, {
                                variant: "unstyled",
                                overflow: "hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm/* Tbody */.p3, {
                                    children: react.Children.toArray(featureSection.features.map((feature, featureIndex)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(table_dist_index_esm.Tr, {
                                            display: "flex",
                                            justifyContent: "space-between",
                                            ml: -6,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    borderBottom: "1px solid #E4E9F2",
                                                    minW: "249.5px",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                                                        flexDir: "row",
                                                        alignItems: "center",
                                                        justify: "space-between",
                                                        w: "full",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                children: feature.name
                                                            }),
                                                            feature.tooltip && !feature.comingSoon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip, {
                                                                popoverClassName: "ml-1.5",
                                                                buttonClassName: "relative",
                                                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionMarkCircleIcon/* default */.Z, {
                                                                    className: "inline-block w-5 h-5 text-gray-400 fill-current -top-0.5"
                                                                }),
                                                                content: feature.tooltip
                                                            }) : feature.comingSoon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                fontSize: "xs",
                                                                px: 1,
                                                                color: "primary.500",
                                                                bgColor: "primary.25",
                                                                borderRadius: "0.25rem",
                                                                whiteSpace: "nowrap",
                                                                children: feature.comingSoon
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                        ]
                                                    })
                                                }),
                                                react.Children.toArray(feature.tiers.map((tier)=>{
                                                    const lastBusinessCell = tier.title === "Business" && index === featureSections.length - 1 && featureIndex === featureSection.features.length - 1;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        borderBottom: !lastBusinessCell ? "1px solid #E4E9F2" : "none",
                                                        textAlign: "center",
                                                        w: "100%",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                            minW: "129px",
                                                            children: typeof tier.value === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                                                children: [
                                                                    " ",
                                                                    tier.value
                                                                ]
                                                            }) : tier.value === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                                as: CheckIcon/* default */.Z,
                                                                color: "primary.500",
                                                                pos: "relative"
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                children: "—"
                                                            })
                                                        })
                                                    }, "".concat(feature.name, " + ").concat(tier.title));
                                                }))
                                            ]
                                        }, feature.name);
                                    }))
                                })
                            })
                        ]
                    })))
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@chakra-ui/accordion/dist/index.esm.js + 2 modules
var accordion_dist_index_esm = __webpack_require__(66046);
;// CONCATENATED MODULE: ./components/pricing/faqs.tsx




const faqs = [
    {
        question: "Why should I trust Clerk with my users?",
        answer: "<div><p>Security is always on our mind. We read and study <a href='https://pages.nist.gov/800-63-3/'>NIST guidelines</a> for fun.</p></br><p> We do external security audits every year, and for every feature written. We implement proactive security measures for your applications such as password breach detection, using a huge database of leaked passwords.</p> </br> <p> You can learn more about security at Clerk on our <a href='/docs/security/introduction'>security</a> page. If you have any specific questions, <a href='/support'>contact us</a>, we love to nerd out about this stuff.</p><div>"
    },
    {
        question: "What happens if I surpass 5000 MAUs on the free plan?",
        answer: "We won't stop people from signing in -- however, we will ask you to upgrade to our 'Hobby' plan.  We've priced Clerk to be affordable for every type of company, (and much cheaper than the competition!)"
    },
    {
        question: "What happens if I stop using Clerk?",
        answer: "We'd be sad to see you go!  We would greatly appreciate any feedback good or bad on how we could do better. However, we understand things happen and we make it really easy to export all of your data. Just <a href='/support'>contact us</a>, and we'll start an export for you.  <br><br>Note: that we store all passwords as a bcrypt hash, and cannot export raw passwords."
    },
    {
        question: "Do you have any special offers for Startups?",
        answer: "We do! We have deals with a lot of seed accelerators and VCs.  Checkout our <a href='/startups'>startups page</a>  and reach out.  Once we verify your account, we'll be able to add your credits."
    }
];
function FAQs() {
    const [hydrated, setHydrated] = (0,react_production_min.useState)(false);
    (0,react_production_min.useEffect)(()=>{
        // This forces a rerender, so the date is rendered
        // the second time but not the first
        setHydrated(true);
    }, []);
    if (!hydrated) {
        // Returns null on first render, so the client and server match
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_container/* LayoutContainer */.k, {
        bg: "white",
        verticalPadding: "none",
        py: "70px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Center */.M5, {
            flexDir: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                    as: "h3",
                    size: "h2",
                    mb: 8,
                    children: "FAQs"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
                    w: {
                        lg: "572px"
                    },
                    allowToggle: true,
                    children: faqs.map((param, i)=>/*#__PURE__*/ {
                        let { answer , question  } = param;
                        return (0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionItem */.Qd, {
                            border: "none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
                                    py: 5,
                                    borderBottom: "1px solid",
                                    borderColor: "gray.100",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                            flex: "1",
                                            textAlign: "left",
                                            textStyle: "label-md",
                                            color: "gray.700",
                                            children: question
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionIcon */.XE, {
                                            color: "gray.500"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
                                    py: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                        textStyle: "paragraph-md",
                                        color: "gray.500",
                                        dangerouslySetInnerHTML: {
                                            __html: answer
                                        }
                                    })
                                })
                            ]
                        }, question);
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/common/partner-logos.tsx
var partner_logos = __webpack_require__(35618);
// EXTERNAL MODULE: ./components/common/rounded-corner.tsx
var rounded_corner = __webpack_require__(77510);
// EXTERNAL MODULE: ./components/common/newsletter.tsx
var newsletter = __webpack_require__(56224);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(13342);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(65820);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 109 modules
var motion = __webpack_require__(85858);
// EXTERNAL MODULE: ./pages/_app.tsx + 95 modules
var _app = __webpack_require__(65524);
;// CONCATENATED MODULE: ./pages/pricing.tsx









const planInfo = [
    {
        badgeText: "Free",
        price: "$0",
        description: "Unlimited sign-ins, no credit card required. Limit 5,000 monthly active users.",
        features: [
            "Verification emails",
            "Custom domains",
            "Pre-built components",
            "Clerk branding",
            "Community support"
        ],
        featuresTitle: "Included features"
    },
    {
        badgeText: "Hobby",
        price: "$25",
        description: "Essential features for launching and growing any application.",
        features: [
            "Unlimited MAUs",
            "Allowlist/Blocklist",
            "Additional MAUs/MAOs",
            "Remove Clerk Branding",
            "Verification SMSs"
        ],
        featuresTitle: "Everything in free, plus"
    },
    {
        badgeText: "Business",
        price: "$99",
        description: "Everything you need for building a business.",
        features: [
            "Custom session duration",
            "Multifactor authentication",
            "User impersonation",
            "Device management",
            "Priority support & SOC2 Report"
        ],
        featuresTitle: "Everything in hobby, plus"
    },
    {
        badgeText: "Enterprise",
        price: "Contact Us",
        description: "Bulk discounts, custom contracts and enterprise support.",
        features: [
            "Bulk discounts",
            "99.99% Uptime SLA",
            "Custom feature dev",
            "HIPAA BAA",
            "Premium support, 24/7/365"
        ],
        featuresTitle: "Everything in business, plus"
    }
];
const Pricing = ()=>{
    const [isSmallerThan1000] = (0,index_esm/* useMediaQuery */.ac)("(max-width: 1000px)");
    const [isLargerThan1400] = (0,index_esm/* useMediaQuery */.ac)("(min-width: 1400px)");
    (0,react_production_min.useEffect)(()=>{
        pages.analytics.page("Marketing_Pricing_Page Viewed");
        (0,_app.rudderPage)("Marketing_Pricing_Page Viewed");
    }, []);
    const [shouldRender, setShouldRender] = (0,react_production_min.useState)(false);
    (0,react_production_min.useEffect)(()=>{
        setShouldRender(true);
    }, []);
    // Workaround to prevent `Hydration failed because the initial UI does not match what was rendered on the server.`
    if (!shouldRender) return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
        h: "100vh",
        w: "100vw"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_container/* LayoutContainer */.k, {
                pos: "relative",
                verticalPadding: "none",
                noHorizontalPadding: true,
                bgGradient: "linear(to-br, #E5F8FF 0%, white 40%, #E5F8FF 100%)",
                pt: "80px",
                zIndex: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Grid */.rj, {
                            templateColumns: !isLargerThan1400 ? {
                                base: "repeat(1, 1fr)",
                                md: "repeat(2, 1fr)"
                            } : "repeat(4, 1fr)",
                            gap: "44px",
                            justifyContent: "space-evenly",
                            children: planInfo.map((plan, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* GridItem */.P4, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                        badgeText: plan.badgeText,
                                        price: plan.price,
                                        description: plan.description,
                                        featuresTitle: plan.featuresTitle,
                                        features: plan.features
                                    })
                                }, index))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(partner_logos/* PartnerLogos */.k, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rounded_corner/* RoundedCorner */.A, {
                        xPosition: "left",
                        yPosition: "bottom",
                        bg: "#FAFDFF",
                        canvasHeight: 160
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rounded_corner/* RoundedCorner */.A, {
                        xPosition: "right",
                        yPosition: "bottom",
                        bg: "#E5F8FF",
                        canvasHeight: 160
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
                spacing: {
                    base: "80px"
                },
                bg: "white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Heading */.X6, {
                        alignSelf: "center",
                        pos: "relative",
                        display: "flex",
                        flexDir: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: {
                            base: "40px",
                            lg: "56px"
                        },
                        mt: "80px",
                        children: [
                            "Plan Features",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                    transition: {
                                        ease: "linear",
                                        duration: 2,
                                        repeat: Infinity
                                    },
                                    animate: {
                                        y: [
                                            null,
                                            10,
                                            20,
                                            10,
                                            0
                                        ]
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                        as: ChevronDownIcon/* default */.Z,
                                        h: "38px",
                                        w: "38px",
                                        color: "primary.500"
                                    })
                                })
                            })
                        ]
                    }),
                    isSmallerThan1000 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PlansTableMobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PlansTable, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                        bg: "white",
                        py: {
                            base: 20,
                            lg: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(newsletter/* NewsLetter */.M, {})
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pricing = (Pricing);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2514,9774,2888,179], function() { return __webpack_exec__(2691); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);